import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { LOGIN_BUTTON_ID } from '../../../constants/layout';
import { DEVIS_BUFFET, MIDI_COMMANDES } from '../../../constants/routing';
import { localizeUrl } from '../../../utils/tools';
import { Button } from '../../atoms/Button';
import { Box } from '@mui/material';

type HeaderActionButtonsProps = {
  isHeader?: boolean;
  onClick?: () => void;
};

export const HeaderActionButtons = ({ isHeader = true, onClick }: HeaderActionButtonsProps) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  return (
    <Box sx={{
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
      columnGap: '3rem',
      rowGap: '2rem'
    }}>
      <Button
        to={localizeUrl(MIDI_COMMANDES)}
        id={isHeader ? LOGIN_BUTTON_ID : `${MIDI_COMMANDES}_other`}
        target="_self"
        variant="contained"
        isBig={true}
        isActive={pathname === localizeUrl(MIDI_COMMANDES)}
        onClick={onClick}
        sx={{ order: 2 }}
      >
        {t('header.link.commandes').toUpperCase()}
      </Button>
      <Button
        to={localizeUrl(DEVIS_BUFFET)}
        variant="contained"
        isBig={true}
        isActive={pathname === localizeUrl(DEVIS_BUFFET)}
        onClick={onClick}
        sx={{ order: 3, px: '3rem' }}
      >
        {t('header.link.devis').toUpperCase()}
      </Button>
    </Box>
  );
};
